import React from 'react';
import {get} from 'lodash';

import {
  availableBanTimes,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import {
  canBan,
} from '../lib/policies';

import UserNoteEditModal from './UserNoteEditModal';

const BulkPenaltyTools = ({
  userIds = [],
}) => {
  const [
    modal,
    modalSet,
  ] = useModal()  // UserNoteEditModal has its own way of keyboard bindings.

  return (
    <React.Fragment>
      <a
        title='Kenta'
        className='TableChecker__right__a TableChecker__right__a--lock'
        disabled={userIds.length == 0}
        onClick={() => {
          modalSet(get(availableBanTimes, '[0].key'))
        }}
      />

      {canBan('User') &&
        <a
          title='Ban'
          className='TableChecker__right__a TableChecker__right__a--no-entry'
          disabled={userIds.length == 0}
          onClick={() => {
            modalSet('permanent')
          }}
        />
      }

      <UserNoteEditModal
        isActive={modal}
        isBanning
        onToggleModal={() => {
          modalSet(false)
        }}
        userIds={userIds}
        banTime={modal}
        mode='bulk'  // Make sure you supply the `endPoints` when using `mode='bulk'`.
        endPoints={{
          penalty: 'api/bulk/penalties',
          note: 'api/bulk/notes',
        }}
      />
    </React.Fragment>
  );
}

export default BulkPenaltyTools
